import { Component, OnInit, Output, ViewChild, EventEmitter, ChangeDetectorRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GraphService } from 'src/app/services/graph.service';
declare const $:any;

@Component({
  selector: 'smart-graph-history-filter',
  templateUrl: './graph-history-filter.component.html',
  styleUrls: ['../graph-color.css','../../platform-color/platform-color.css']
})
export class GraphHistoryFilterComponent implements OnInit {
  @Input() id: string;
  form: FormGroup;
  submitted = false;
  loading: boolean = true;

  farms = [];
  plots = [];
  things = [];
  sens = [];
  types = [
    { id: 'Min',label: 'MIN'},
    { id: 'Max',label: 'MAX'},
    { id: 'AVG',label: 'AVG'},
    { id: 'SUM',label: 'SUM'}
  ]

  plotDashboards = [];
  senserData = [];

  emptySensorModal: string = '#emptySensorModal';
  emptyPlotModal: string = '#emptyPlotModal';
  emptyThingModal: string ='#emptyThingModal';
  limitGraphModal: string = '#limitGraphModal';

  @Output() done = new EventEmitter<any>();
  
  @ViewChild('closebutton') closeButton;

  number_of_sensor: number = 0;
  
  constructor(
    private formBuilder: FormBuilder,
    private GraphService: GraphService,
    private cd: ChangeDetectorRef
    ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.valueChange();
    this.getFarmselect();
  }

  createForm(){
    this.form = this.formBuilder.group({
      farm: ["", [Validators.required]],
      plot: ["", [Validators.required]],
      thing: ["", [Validators.required]],
      sensor: ["", [Validators.required]],
      type: ["", [Validators.required]],
    })
  }

  valueChange(){

    this.form.controls.farm.valueChanges.subscribe(async (value) => {

        if(value != this.form.value['farm']){
          this.form.get('plot').setValue("");
          this.form.get('thing').setValue("");
          this.form.get('sensor').setValue("");
          this.form.get('type').setValue("");
          
          await this.GraphService.getPlotDashboard(value[0].id)
          .then(success => {

            this.plotDashboards = success.data.plot;

            this.plots = this.plotDashboards.map(plot=>{
              return {
                id: plot._id,
                label: plot.name,
                data: plot
              }
            });
            this.resetTemplate();
          }).catch(err=>{

            this.plots = [];
            this.things = [];
            this.senserData = [];
            $(`${this.emptyPlotModal}`).modal('show');

            this.resetTemplate();
          });
        }
    });

    this.form.controls.plot.valueChanges.subscribe(async (value) => {

      if (value != this.form.value["plot"]) {
        this.form.get('thing').setValue("");
        this.form.get('sensor').setValue("");
        this.things = [];


        if (value[0]) {

          let plot = this.form.getRawValue().plot;
          let plotList = []
          plot.map(item=>{
            let plotDashboard = this.plotDashboards.filter(plot=> plot._id == item.id);

            if(plotDashboard.length > 0){
              plotDashboard.map(plot=>{
                plotList.push(plot);
              })
            }
          })

          await Promise.all(plotList
            .map(async plot=>{

              await Promise.all(plot.thing
                .map(async thing=>{

                  this.things.push(
                    {
                      id:  thing.thing_id,
                      label: thing.thing_name,
                      data: thing
                    }
                  )
              }));
  
              if(this.things.length > 0){

              }else{
                this.things = [];
                $(`${this.emptyThingModal}`).modal("show");
              }
              this.resetTemplate();
          }));
        }
      }
    });

    this.form.controls.thing.valueChanges.subscribe(async (value) => {

      if (value != this.form.value["thing"]) {
        this.form.get("sensor").setValue("");
        this.sens = [];
        
        if (value[0]) {

          let plot = this.form.getRawValue().plot;
          let thingList = []
          plot.map(item=>{
            let plotDashboard = this.plotDashboards.filter(plot=> plot._id == item.id);

            if(plotDashboard.length > 0){
              plotDashboard.map(plot=>{
                plot.thing.map(item=>{
                  thingList.push(item);
                })
              })
            }
          });
         
          if(thingList.length > 0){
            this.sens = [];
            let filterThing = this.form.getRawValue().thing;

            if(filterThing.length >0){
              await Promise.all(filterThing
                .map(async thing=>{

                  thingList.find(item=> item.thing_id == thing.id).sensor.map(sen=>{
                    this.sens.push(
                      {
                        id: sen.sensor_id+thing.id,
                        label: sen.sensor_name,
                        data: sen
                      }
                    )
                  })
              }));
              if(this.sens.length ==0){
                $(`${this.emptySensorModal}`).modal("show");
              }
            }else{
              this.sens = [];
              $(`${this.emptySensorModal}`).modal("show");
            }
          }
        }
      }
    });

    this.form.controls.sensor.valueChanges.subscribe(async (value) => {
        if (value != this.form.value["sensor"]) {
          let sensor = this.form.getRawValue().sensor || [];
          let type = this.form.getRawValue().type || [];

          if((sensor.length) > this.number_of_sensor){
            sensor.splice(-1);
            this.form.get("sensor").setValue(sensor);

            $(`${this.limitGraphModal}`).modal('show');
          }else{
            if(type.length == sensor.length && (type.length+ sensor.length)/2 == this.number_of_sensor && this.number_of_sensor > 1){
              sensor.splice(-1);
              this.form.get("sensor").setValue(sensor);
    
              $(`${this.limitGraphModal}`).modal('show');
            }
          }
          this.resetTemplate();
        }
    });

    this.form.controls.type.valueChanges.subscribe(async (value) => {
      if (value != this.form.value["type"]) {
        let type = this.form.getRawValue().type || [];
        let sensor = this.form.getRawValue().sensor || [];

        if((type.length) > this.number_of_sensor){

          type.splice(-1);
          this.form.get("type").setValue(type);

          $(`${this.limitGraphModal}`).modal('show');
        }else{
          if(type.length == sensor.length && (type.length+ sensor.length)/2 == this.number_of_sensor && this.number_of_sensor > 1){
            type.splice(-1);
            this.form.get("type").setValue(type);
  
            $(`${this.limitGraphModal}`).modal('show');
          }
        }
        this.resetTemplate();
      }
  });
  }

  async getFarmselect() {
    this.loading = true;

    const currentPackage = JSON.parse(sessionStorage.getItem('package'));
    try{
      if(currentPackage){
        await this.GraphService.getPackage(currentPackage['package_id']).then(res=>{
          this.number_of_sensor = res.data.sensor_no;
        });
      }
      await this.GraphService.getDropdownDashboard()
      .then(success => {
        this.farms = success.data.FarmList.map(farm=>{
          return {
            id: farm._id,
            label: farm.name
          }
        });
  
        this.loading = false;
        this.resetTemplate();
      });
    }catch(error){
      this.loading = false;
      this.resetTemplate();
    }
  }

  patchValue(e, controlName){
    this.form.get(controlName).setValue(e);
  }

  async onSave() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.submitted = false;

    let data = {
      ...this.form.getRawValue()
    }

    data.sensor.map(item=>{
      item.data = this.sens.find(sen=> sen.id == item.id && item.label == sen.label).data;
    })

    this.done.emit(data);
    this.close();
  }
  close() {
    this.submitted = false;
    this.closeButton.nativeElement.click();
  }

  resetTemplate(){
    this.cd.detectChanges();
  }
}
